module.exports = __webpack_public_path__ + "bl.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/bl.svg
// module id = 454
// module chunks = 0